let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("107sG")).then(() => parcelRequire('9Qg7T'));